export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('form_label_storeName') || '商铺名称',
    field: 'storeName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_importDate') || '导入日期',
    field: 'importDate',
    width: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_sellDate') || '日期',
    field: 'sellDate',
    width: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_orderedProductSales') || '订单产品销售金额',
    field: 'orderedProductSales',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_orderedProductSalesB2b') || '订单产品销售金额（B2B）',
    field: 'orderedProductSalesB2b',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_unitsOrdered') || '订单件数',
    field: 'unitsOrdered',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_unitsOrderedB2b') || '订单件数（B2B）',
    field: 'unitsOrderedB2b',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_totalOrderItems') || '订单单品数',
    field: 'totalOrderItems',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_totalOrderItemsB2b') || '订单单品数（B2B）',
    field: 'totalOrderItemsB2b',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_averageSalesPerOrderItem') || '每订单单件销售金额',
    field: 'averageSalesPerOrderItem',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_averageSalesPerOrderItemB2b') || '每订单单件销售金额(B2B)',
    field: 'averageSalesPerOrderItemB2b',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_averageUnitsPerOrderItem') || '每订单件数平均单品数',
    field: 'averageUnitsPerOrderItem',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_averageUnitsPerOrderItemB2b') || '每订单件数平均单品数(B2B)',
    field: 'averageUnitsPerOrderItemB2b',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_averageSellingPrice') || '平均销售价格',
    field: 'averageSellingPrice',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_averageSellingPriceB2b') || '平均销售价格(B2B)',
    field: 'averageSellingPriceB2b',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_sessionsTotal') || '季节总计',
    field: 'sessionsTotal',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_orderItemSessionPercentage') || '订单单件季节百分比',
    field: 'v_orderItemSessionPercentage',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_orderItemSessionPercentageB2b') || '订单单件季节百分比(B2B)',
    field: 'v_orderItemSessionPercentageB2b',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_averageOfferCount') || 'averageOfferCount',
    field: 'averageOfferCount',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'creationTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'updatedTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
